import moment from 'moment-timezone';
import { FONT_FAMILY } from '@utils/constants';
import { TOOLTIP_LABEL_FORMAT } from '@components/common/Charts/utils';
import humanizeValue from '@utils/overview/humanizeValue';
import { humanize } from '@utils';
import { getMetricUnit, getMetricUnitText, getMetricOvbDisplayName } from '@utils/metrics';
import { query as originQuery } from '../metricsData/schema';

const createQuery = (metricName, interval, filter, granularity, kpiConfig) => {
  const query = {
    ...originQuery,
    interval,
    filter,
    granularity,
    metrics: metricName,
  };

  query.options.kpiConfig = kpiConfig;

  return {
    queries: [query],
  };
};

const formatMetricDataForChart = (data, metricKey, color) => {
  const chartData: any = data.map((eachItem) => [eachItem.timestamp, eachItem.results[metricKey]]);

  const tooltipFormatter = (params) => {
    const unit = getMetricUnit({ metricKey });
    const value = params[0].data;
    const yVal = humanize(value[1], unit);
    const metricDisplayName = getMetricOvbDisplayName({ metricKey });
    const xVal = moment(value[0]).format(TOOLTIP_LABEL_FORMAT);
    return `${xVal}<br/>${metricDisplayName} - <b>${yVal}${getMetricUnitText(unit)}</b>`;
  };

  const option: any = {
    color: [color],
    grid: {
      left: 35,
      bottom: 28,
      right: 20,
      top: 5,
    },
    tooltip: {
      trigger: 'axis',
      formatter: tooltipFormatter,
      font: FONT_FAMILY,
    },
    xAxis: {
      type: 'time',
      show: false,
    },
    yAxis: {
      type: 'value',
      show: false,
    },
    series: [
      {
        data: chartData,
        type: 'line',
        showSymbol: false,
        areaStyle: {
          opacity: 0,
        },
        lineStyle: {
          width: 1,
        },
      },
    ],
  };
  return option;
};

const formatResponse = (metricsData, filterColor, audienceMetrics) => {
  const formattedResponse = {} as any;
  try {
    if (metricsData.response != null) {
      const totals = metricsData.response[0].totals;
      audienceMetrics.forEach((metricKey) => {
        const response = humanizeValue(totals[metricKey] as number, metricKey);
        formattedResponse[metricKey] = {};
        formattedResponse[metricKey].metricKey = metricKey;
        formattedResponse[metricKey].humanizedNumber = response.humanizedNumber;
        formattedResponse[metricKey].humanizedUnit = response.humanizedUnit;
        formattedResponse[metricKey].chartData = formatMetricDataForChart(
          metricsData.response[0].data,
          metricKey,
          filterColor,
        );
        formattedResponse[metricKey].displayName = getMetricOvbDisplayName({ metricKey });
      });
    }
  } catch (err) {
    // ignore
  }
  return formattedResponse;
};

export { createQuery, formatResponse };
